<template>
  <div class="workspace-agency-dashboard workspace-overview">
    <header class="workspace-page-header"><div><h1>Welcome back<span v-if="me && me.first_name">, {{ me.first_name }}</span></h1><p>Here’s how your agency’s accounts are doing.</p></div></header>
    <v-skeleton-loader v-if="fetchingStats" type="card" />
    <section v-else class="workspace-kpi-grid" aria-label="Key numbers">
      <article v-if="me && me.id == 1353" class="workspace-kpi"><div><span>Total agencies</span><i class="mdi mdi-office-building-outline" aria-hidden="true"></i></div><strong>{{ stats.stats.total_agencies }}</strong><small>Sub-agency accounts</small></article>
      <article class="workspace-kpi"><div><span>Total businesses</span><i class="mdi mdi-briefcase-outline" aria-hidden="true"></i></div><strong>{{ stats.stats.total_businesses }}</strong><small>Across your agency</small></article>
      <article class="workspace-kpi"><div><span>Total locations</span><i class="mdi mdi-map-marker-outline" aria-hidden="true"></i></div><strong>{{ stats.stats.total_locations }}</strong><small>Across your businesses</small></article>
      <article class="workspace-kpi"><div><span>New businesses</span><i class="mdi mdi-trending-up" aria-hidden="true"></i></div><strong>{{ stats.stats.total_businesses_this_month }}</strong><small>Added this month</small></article>
    </section>
    <div class="workspace-overview-columns">
      <section class="workspace-panel"><header class="workspace-panel-heading"><h2>Latest reviews</h2><router-link to="/reviews">View all →</router-link></header>
        <div v-if="!fetchingStats && me && me.id == 1353" class="workspace-review-totals"><span>Requests <b>{{ stats.stats.review_requests_sent }}</b></span><span>Link clicks <b>{{ stats.stats.review_links_clicked }}</b></span><span>Negative feedback <b>{{ stats.stats.negative_feedback_count }}</b></span><span>Reviews gathered <b>{{ stats.stats.review_gathered_count }}</b></span></div>
        <workspace-recent-reviews dashboard="true" />
      </section>
      <section class="workspace-panel"><header class="workspace-panel-heading"><h2>Recent activity</h2><router-link to="/activity">View all →</router-link></header>
        <v-skeleton-loader v-if="fetchingActivity" type="list-item-avatar-two-line, list-item-avatar-two-line" />
        <p v-else-if="!activity.length" class="workspace-empty">No activity yet.</p>
        <div v-else class="workspace-activity-feed"><article v-for="item in activity" :key="item.id" class="workspace-activity-row">
          <span class="workspace-avatar workspace-avatar--small" aria-hidden="true">{{ [item.user.first_name, item.user.last_name].filter(Boolean).map(name => name[0]).join('') || '?' }}</span>
          <div><p><strong>{{ item.user.first_name }} {{ item.user.last_name }}</strong> <span>{{ item.details.toLowerCase() }}</span></p><small>{{ item.user.company_type === 'location' && item.user.parent ? item.user.parent.company_name : item.user.company_name }}<span v-if="item.user.city"> · {{ item.user.city }}</span></small></div>
          <time :title="item.created_at">{{ formatDate(item.created_at) }}</time>
        </article></div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import WorkspaceRecentReviews from '@/components/workspace/RecentReviews.vue'
import moment from 'moment'

export default {
  components: {
    WorkspaceRecentReviews
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      me: (state) => state.me.me,
      activity: state => state.activity.activity,
      fetchingActivity: state => state.activity.fetchingActivity,
      stats: state => state.stats.stats,
      fetchingStats: state => state.stats.fetchingStats
    }),
  },
  methods: {
    formatDate: function(date) {
      return moment(String(date)).fromNow()
    },
  },
  created() {
    this.$store.state.activity.fetchingActivity = true
    this.$store.dispatch('activity/fetch', {
      date_filter: [],
      search: ""
    })

    this.$store.state.stats.fetchingStats = true
    this.$store.dispatch('stats/fetch')
  }
}
</script>

<style type="text/css">
  
</style>